import { render, staticRenderFns } from "./MyCompanyReportsUsers.vue?vue&type=template&id=6fa72120&scoped=true&"
import script from "./MyCompanyReportsUsers.vue?vue&type=script&lang=js&"
export * from "./MyCompanyReportsUsers.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyReportsUsers.vue?vue&type=style&index=0&id=6fa72120&lang=scss&scoped=true&"
import style1 from "./MyCompanyReportsUsers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa72120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect})
